"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullableStringValue = exports.isNotEmptyStringValue = exports.isEmptyStringValue = void 0;
const primitives_1 = require("./primitives");
const typing_1 = require("./typing");
const isEmptyStringValue = (fieldValue) => {
    return (0, primitives_1.isStringValue)(fieldValue) && fieldValue === "";
};
exports.isEmptyStringValue = isEmptyStringValue;
const isNotEmptyStringValue = (fieldValue) => {
    return (0, primitives_1.isStringValue)(fieldValue) && fieldValue.length > 0;
};
exports.isNotEmptyStringValue = isNotEmptyStringValue;
const isNullableStringValue = (fieldValue) => {
    return (0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNullValue)(fieldValue);
};
exports.isNullableStringValue = isNullableStringValue;
